import {Widget as OriginWidget} from "@zasada/widget";
import {Layers} from "base/assets/js/widget/Layers.js";
export class Widget extends OriginWidget {

	post( sUrl, oFormData ) {
		this.newError( {
			sBlockId: "fg"
		} );
		return new Promise( ( hResolve, hReject ) => {
			let oXhr = new XMLHttpRequest();
			oXhr.onreadystatechange = () => {
				if( oXhr.readyState !== 4 ) {
					return;
				}
				if ( oXhr.status === 0 ) {
					hReject( { state: 0, status: 'Проверьте интернет соединение' } );
					return;
				}
				let bError = false;
				if ( oXhr.status < 200 || oXhr.status >= 400 ) {
					bError = true;
				}
				const sContentType = oXhr.getResponseHeader( 'Content-type' );
				const sResponse = oXhr.responseText;
				try {
					if ( sContentType && sContentType.indexOf( 'application/json' ) !== -1 ) {
						const oJson = JSON.parse( sResponse );
						if ( oJson.state && !bError ) {
							hResolve( oJson );
						} else {
							hReject( oJson );
						}
						return;
					}
				} catch( e ) {
					hReject( { state: 0, status: 'Ошибка ' + e } );
				}
				hResolve( { sHtml: sResponse} );
			};
			oXhr.open( 'POST', sUrl, true );
			//if( oFormData ) {
			//	oXhr.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
			//}
			oXhr.setRequestHeader( "X-Requested-With", "XMLHttpRequest" );
			if( oFormData && typeof oFormData === 'object' && !( oFormData instanceof FormData ) ) {
				let oFormDataObj = new FormData();
				for ( let sKey in oFormData ) {
					oFormDataObj.append( sKey, oFormData[ sKey ] );
				}
				oFormData = oFormDataObj;
			}
			oXhr.send( oFormData );
		} );
	}

	ajaxPopupCatch( oJson ) {
		let sMessage = oJson.status || oJson.message;
		if( sMessage ) {
			const oLayers = this._rel().typeOf( Layers ).find();
			oLayers.message( sMessage );
		}
		throw this.newError( { mOrigin: oJson, bSkipLog: true } );
	}
}